import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import { initSentry } from './lib/sentry';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import initScrollReveal from './utils/scrollReveal';

// Runtime debug: confirm entry bundle executed in the browser
console.log('[app] index.tsx loaded');

initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Sentry.ErrorBoundary fallback={<p>An unexpected error occurred.</p>}>
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);

// kick off reveal effects for sections
initScrollReveal();

// Add a visible runtime error overlay so white screens surface the error
function showErrorOverlay(message: string, stack?: string) {
  try {
    const existing = document.getElementById('runtime-error-overlay');
    if (existing) existing.remove();
    const el = document.createElement('div');
    el.id = 'runtime-error-overlay';
    el.style.position = 'fixed';
    el.style.left = '0';
    el.style.right = '0';
    el.style.top = '0';
    el.style.zIndex = '2147483647';
    el.style.background = 'linear-gradient(90deg,#b91c1c,#ef4444)';
    el.style.color = 'white';
    el.style.padding = '12px 18px';
    el.style.fontFamily = 'monospace';
    el.style.fontSize = '13px';
    el.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
    el.style.whiteSpace = 'pre-wrap';
    el.textContent = `Runtime error: ${message}` + (stack ? '\n' + stack : '');
    document.body.appendChild(el);
  } catch (e) {
    // ignore
  }
}

window.addEventListener('error', (ev) => {
  const err = (ev && (ev.error || ev.message)) || String(ev);
  showErrorOverlay(typeof err === 'string' ? err : (err && err.toString && err.toString()));
});

window.addEventListener('unhandledrejection', (ev) => {
  const reason = (ev && ev.reason) || 'Unhandled promise rejection';
  showErrorOverlay(typeof reason === 'string' ? reason : (reason && reason.stack) || String(reason));
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
